import getAppSite from 'utils/getAppSite';
import { commentatorsTypes } from 'components/Dashboard/UserContent/ui/PoliticalUpdates';
import currentDate from 'components/Dashboard/utilities/currentDateUTC';

const Sections = [
  {
    name: 'ParliamentLive',
    type: 'RealtimeUtterance',
    hidden: getAppSite() === 'usa',
  },
  {
    name: 'KeyUpdates',
    type: 'KeyUpdate',
  },
  {
    name: 'Consultations',
    type: 'Consultation',
    filters: [{ field: 'closeDate', value: currentDate, operator: 'DATE_GTE' }],
    hidden: getAppSite() === 'usa',
  },
  {
    name: 'Legislation',
  },
  {
    name: 'ParliamentaryRecord',
    collapseField: 'contentUrl',
  },
  {
    name: 'LibraryMaterial',
    type: 'CommonsLibraryArticle',
    hidden: getAppSite() === 'usa',
  },
  {
    name: 'CommitteePublications',
    type: 'CommitteePublication',
    hidden: getAppSite() === 'usa',
  },
  {
    name: 'UpcomingEvents',
    type: 'Event',
    urlName: 'calendar',
    hidden: getAppSite() === 'usa',
  },
  {
    name: 'Stakeholders',
    type: 'stakeholder',
  },
  {
    name: 'Tweets',
    type: 'tweet',
    filters: commentatorsTypes,
    hidden: getAppSite() === 'usa',
  },
  {
    name: 'LobbyingMaterial',
    type: 'UserContent',
  },
];

if (import.meta.env.VITE_APP_ENABLE_TWITTER === 'false') {
  let twitterPosition = Sections.findIndex((item) => item.name === 'Tweets');
  Sections.splice(twitterPosition, 1);
}

export default Sections;
